import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { ReportState } from "./type";
import { generateQueryString } from "../helper/helpers";

export const getMetricChart = createAsyncThunk(
  "web/get-metric-chart",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/nps-report/metric-description${generateQueryString(payload)}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_METRIC_CHART(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getActivityChart = createAsyncThunk(
  "web/get-activity-chart",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/nps-report/nps-activity-chart${generateQueryString(payload)}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_ACTIVITY_CHART(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getNpsRecord = createAsyncThunk(
  "web/get-nps-record",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/nps-report${generateQueryString(payload)}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_NPS_RECORD(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const exportNpsRecord = createAsyncThunk(
  "web/export-nps-record",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/nps-report?export=csv`, {
        responseType: "blob",
        headers: { Accept: "text/csv" },
      });

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status) {
        console.log(data?.status);
        const obj = data?.data;

        // Create a Blob from the CSV data
        const blob = new Blob([obj], { type: "text/csv" });

        // Create a temporary URL to the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link element and trigger the download
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "nps-report.csv";
        document.body.appendChild(a);
        a.click();

        // Clean up the temporary URL and link
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getNpsUserRecord = createAsyncThunk(
  "web/get-user-nps-record",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/nps-report/user/${payload.id}${generateQueryString(
          payload.param
        )}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_NPS_USER_RECORD(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAppVersions = createAsyncThunk(
  "web/get-mobile-versions",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/nps-report/app-versions-list`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_APP_VERSIONS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: ReportState = {
  loading_activity: false,
  loading_metric: false,
  activity_chart: {},
  metric_chart: {},
  app_versions: [],
  loading_nps_record: false,
  nps_record: {},
  nps_user_record: {},
};

export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    SET_METRIC_CHART: (state, action) => {
      state.metric_chart = action.payload;
    },
    SET_ACTIVITY_CHART: (state, action) => {
      state.activity_chart = action.payload;
    },
    SET_APP_VERSIONS: (state, action) => {
      state.app_versions = action.payload;
    },
    SET_NPS_RECORD: (state, action) => {
      state.nps_record = action.payload;
    },
    SET_NPS_USER_RECORD: (state, action) => {
      state.nps_user_record = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMetricChart.pending, (state) => {
        state.loading_metric = true;
      })
      .addCase(getMetricChart.fulfilled, (state) => {
        state.loading_metric = false;
      })
      .addCase(getMetricChart.rejected, (state) => {
        state.loading_metric = false;
      })
      .addCase(getActivityChart.pending, (state) => {
        state.loading_activity = true;
      })
      .addCase(getActivityChart.fulfilled, (state) => {
        state.loading_activity = false;
      })
      .addCase(getActivityChart.rejected, (state) => {
        state.loading_activity = false;
      })
      .addCase(getNpsRecord.pending, (state) => {
        state.loading_nps_record = true;
      })
      .addCase(getNpsRecord.fulfilled, (state) => {
        state.loading_nps_record = false;
      })
      .addCase(getNpsRecord.rejected, (state) => {
        state.loading_nps_record = false;
      })
      .addCase(getNpsUserRecord.pending, (state) => {
        state.loading_nps_record = true;
      })
      .addCase(getNpsUserRecord.fulfilled, (state) => {
        state.loading_nps_record = false;
      })
      .addCase(getNpsUserRecord.rejected, (state) => {
        state.loading_nps_record = false;
      })
      .addCase(exportNpsRecord.pending, (state) => {
        state.loading_nps_record = true;
      })
      .addCase(exportNpsRecord.fulfilled, (state) => {
        state.loading_nps_record = false;
      })
      .addCase(exportNpsRecord.rejected, (state) => {
        state.loading_nps_record = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_METRIC_CHART,
  SET_ACTIVITY_CHART,
  SET_APP_VERSIONS,
  SET_NPS_RECORD,
  SET_NPS_USER_RECORD,
} = reportSlice.actions;

export default reportSlice.reducer;
